/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PlaygroundImport } from './routes/playground'
import { Route as LayoutV1Import } from './routes/_layoutV1'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout.index'
import { Route as LayoutTransactionsImport } from './routes/_layout.transactions'
import { Route as LayoutSessionsImport } from './routes/_layout.sessions'
import { Route as LayoutRecoveryV1Import } from './routes/_layout.recovery-v1'
import { Route as LayoutRecoveryImport } from './routes/_layout.recovery'
import { Route as LayoutPortfolioImport } from './routes/_layout.portfolio'
import { Route as LayoutAssetsImport } from './routes/_layout.assets'
import { Route as LayoutAboutImport } from './routes/_layout.about'
import { Route as LayoutEmailVerifyImport } from './routes/_layout.email.verify'

// Create/Update Routes

const PlaygroundRoute = PlaygroundImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRoute,
} as any)

const LayoutV1Route = LayoutV1Import.update({
  id: '/_layoutV1',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTransactionsRoute = LayoutTransactionsImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSessionsRoute = LayoutSessionsImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutRecoveryV1Route = LayoutRecoveryV1Import.update({
  id: '/recovery-v1',
  path: '/recovery-v1',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutRecoveryRoute = LayoutRecoveryImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPortfolioRoute = LayoutPortfolioImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAssetsRoute = LayoutAssetsImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAboutRoute = LayoutAboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEmailVerifyRoute = LayoutEmailVerifyImport.update({
  id: '/email/verify',
  path: '/email/verify',
  getParentRoute: () => LayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/_layoutV1': {
      id: '/_layoutV1'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutV1Import
      parentRoute: typeof rootRoute
    }
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundImport
      parentRoute: typeof rootRoute
    }
    '/_layout/about': {
      id: '/_layout/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof LayoutAboutImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/assets': {
      id: '/_layout/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof LayoutAssetsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/portfolio': {
      id: '/_layout/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof LayoutPortfolioImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/recovery': {
      id: '/_layout/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof LayoutRecoveryImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/recovery-v1': {
      id: '/_layout/recovery-v1'
      path: '/recovery-v1'
      fullPath: '/recovery-v1'
      preLoaderRoute: typeof LayoutRecoveryV1Import
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions': {
      id: '/_layout/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof LayoutSessionsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/transactions': {
      id: '/_layout/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof LayoutTransactionsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/email/verify': {
      id: '/_layout/email/verify'
      path: '/email/verify'
      fullPath: '/email/verify'
      preLoaderRoute: typeof LayoutEmailVerifyImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

interface LayoutRouteChildren {
  LayoutAboutRoute: typeof LayoutAboutRoute
  LayoutAssetsRoute: typeof LayoutAssetsRoute
  LayoutPortfolioRoute: typeof LayoutPortfolioRoute
  LayoutRecoveryRoute: typeof LayoutRecoveryRoute
  LayoutRecoveryV1Route: typeof LayoutRecoveryV1Route
  LayoutSessionsRoute: typeof LayoutSessionsRoute
  LayoutTransactionsRoute: typeof LayoutTransactionsRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutEmailVerifyRoute: typeof LayoutEmailVerifyRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAboutRoute: LayoutAboutRoute,
  LayoutAssetsRoute: LayoutAssetsRoute,
  LayoutPortfolioRoute: LayoutPortfolioRoute,
  LayoutRecoveryRoute: LayoutRecoveryRoute,
  LayoutRecoveryV1Route: LayoutRecoveryV1Route,
  LayoutSessionsRoute: LayoutSessionsRoute,
  LayoutTransactionsRoute: LayoutTransactionsRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutEmailVerifyRoute: LayoutEmailVerifyRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof LayoutV1Route
  '/playground': typeof PlaygroundRoute
  '/about': typeof LayoutAboutRoute
  '/assets': typeof LayoutAssetsRoute
  '/portfolio': typeof LayoutPortfolioRoute
  '/recovery': typeof LayoutRecoveryRoute
  '/recovery-v1': typeof LayoutRecoveryV1Route
  '/sessions': typeof LayoutSessionsRoute
  '/transactions': typeof LayoutTransactionsRoute
  '/': typeof LayoutIndexRoute
  '/email/verify': typeof LayoutEmailVerifyRoute
}

export interface FileRoutesByTo {
  '': typeof LayoutV1Route
  '/playground': typeof PlaygroundRoute
  '/about': typeof LayoutAboutRoute
  '/assets': typeof LayoutAssetsRoute
  '/portfolio': typeof LayoutPortfolioRoute
  '/recovery': typeof LayoutRecoveryRoute
  '/recovery-v1': typeof LayoutRecoveryV1Route
  '/sessions': typeof LayoutSessionsRoute
  '/transactions': typeof LayoutTransactionsRoute
  '/': typeof LayoutIndexRoute
  '/email/verify': typeof LayoutEmailVerifyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/_layoutV1': typeof LayoutV1Route
  '/playground': typeof PlaygroundRoute
  '/_layout/about': typeof LayoutAboutRoute
  '/_layout/assets': typeof LayoutAssetsRoute
  '/_layout/portfolio': typeof LayoutPortfolioRoute
  '/_layout/recovery': typeof LayoutRecoveryRoute
  '/_layout/recovery-v1': typeof LayoutRecoveryV1Route
  '/_layout/sessions': typeof LayoutSessionsRoute
  '/_layout/transactions': typeof LayoutTransactionsRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/email/verify': typeof LayoutEmailVerifyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/playground'
    | '/about'
    | '/assets'
    | '/portfolio'
    | '/recovery'
    | '/recovery-v1'
    | '/sessions'
    | '/transactions'
    | '/'
    | '/email/verify'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/playground'
    | '/about'
    | '/assets'
    | '/portfolio'
    | '/recovery'
    | '/recovery-v1'
    | '/sessions'
    | '/transactions'
    | '/'
    | '/email/verify'
  id:
    | '__root__'
    | '/_layout'
    | '/_layoutV1'
    | '/playground'
    | '/_layout/about'
    | '/_layout/assets'
    | '/_layout/portfolio'
    | '/_layout/recovery'
    | '/_layout/recovery-v1'
    | '/_layout/sessions'
    | '/_layout/transactions'
    | '/_layout/'
    | '/_layout/email/verify'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LayoutV1Route: typeof LayoutV1Route
  PlaygroundRoute: typeof PlaygroundRoute
}

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LayoutV1Route: LayoutV1Route,
  PlaygroundRoute: PlaygroundRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layout",
        "/_layoutV1",
        "/playground"
      ]
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/about",
        "/_layout/assets",
        "/_layout/portfolio",
        "/_layout/recovery",
        "/_layout/recovery-v1",
        "/_layout/sessions",
        "/_layout/transactions",
        "/_layout/",
        "/_layout/email/verify"
      ]
    },
    "/_layoutV1": {
      "filePath": "_layoutV1.tsx"
    },
    "/playground": {
      "filePath": "playground.tsx"
    },
    "/_layout/about": {
      "filePath": "_layout.about.tsx",
      "parent": "/_layout"
    },
    "/_layout/assets": {
      "filePath": "_layout.assets.tsx",
      "parent": "/_layout"
    },
    "/_layout/portfolio": {
      "filePath": "_layout.portfolio.tsx",
      "parent": "/_layout"
    },
    "/_layout/recovery": {
      "filePath": "_layout.recovery.tsx",
      "parent": "/_layout"
    },
    "/_layout/recovery-v1": {
      "filePath": "_layout.recovery-v1.tsx",
      "parent": "/_layout"
    },
    "/_layout/sessions": {
      "filePath": "_layout.sessions.tsx",
      "parent": "/_layout"
    },
    "/_layout/transactions": {
      "filePath": "_layout.transactions.tsx",
      "parent": "/_layout"
    },
    "/_layout/": {
      "filePath": "_layout.index.tsx",
      "parent": "/_layout"
    },
    "/_layout/email/verify": {
      "filePath": "_layout.email.verify.tsx",
      "parent": "/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
